// SideMenuMobile.tsx
import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import { Claims } from '../Models/Claims';
import { useAPIContext } from '../Context/APIContext';

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
}

export default function SideMenuMobile({ open, toggleDrawer }: SideMenuMobileProps) {
  const [claims, setClaims] = useState<Claims>();
  const { apiFetch } = useAPIContext();

  // MOBILE SUBMENU STATE LIFTED HERE
  const [isVideosOpenMobile, setIsVideosOpenMobile] = useState(false);
  const [isDocumentsOpenMobile, setIsDocumentsOpenMobile] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const claims = await apiFetch<Claims>('Auth/Claims', 'GET', Claims.fromJson);
      if (claims) setClaims(claims);
    };
    fetchData();
  }, [apiFetch]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack sx={{ maxWidth: '70dvw', height: '100%' }}>
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack direction="row" sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}>
            <Avatar
              sizes="small"
              alt={`${claims?.givenName} ${claims?.surname}`}
              src="/static/images/avatar/7.jpg"
              sx={{ width: 24, height: 24 }}
            />
            <Typography component="p" variant="h6">
              {`${claims?.givenName} ${claims?.surname}`}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent
            toggleDrawer={toggleDrawer}
            isMobile={true}
            isVideosOpenMobile={isVideosOpenMobile}
            setIsVideosOpenMobile={setIsVideosOpenMobile}

            isDocumentsOpenMobile={isDocumentsOpenMobile}
            setIsDocumentsOpenMobile={setIsDocumentsOpenMobile}
          />
          <Divider />
        </Stack>
      </Stack>
    </Drawer>
  );
}
